import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { QuizQuestion } from 'src/app/models';
import { CoursesService } from 'src/app/services/courses.service';
import { QuizService } from 'src/app/services/quiz.service';

@Component({
  selector: 'app-module6-fhe',
  templateUrl: './module6-fhe.component.html',
  styleUrls: ['./module6-fhe.component.css', '../fair-housing-education.component.css']
})
export class Module6FheComponent implements OnInit {

  constructor(private courseService: CoursesService, private quizService: QuizService, private router: Router) { }

  // Contains all questions for the module
  questions: QuizQuestion[] = [];

  // Determine if quiz has started
  quizStart: boolean = false;

  ngOnInit(): void {
    this.courseService.setCurrentCourseBy('Fair Housing Education');

    // Get the questions for this module and assign them to this.questions
    this.quizService.getModuleQuizzes("61f358370a0a3525d8d3c933").toPromise().then((res: any) => {
      this.quizService.moduleQuizQuestions = res.docs;
      this.questions = this.quizService.moduleQuizQuestions;
    });
  }

  // Update furthestModuleID
  updateProgress() {
    if (this.courseService.currentCourse.furthestModuleID < 6) {
      this.courseService.updateFurthestModule().toPromise().then(res => {
        console.log(res);
      });
    }
  }

  // Start quiz
  startQuiz(event?: Event) {
    if (event?.defaultPrevented) return false;

    this.quizStart = true;

    // Scroll to top
    window.scrollTo(0, 0);

    return true;
  }

  // Handle the quiz results, allow them to pass or not
  handleQuiz(valueEmitted: boolean){

    // Quiz passed
    if (valueEmitted) {
      this.updateProgress();
      this.router.navigate(['/module7-fhe']);
    }

    // Review
    else {
      this.quizStart = false;
    }
  }
}
